import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

/* eslint-disable react/no-array-index-key */
import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import css from './CollectionLoading.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Kid = function Kid(_ref) {
  var fourUp = _ref.fourUp;
  return /*#__PURE__*/_jsx("li", {
    className: cc([css.item, _defineProperty({}, css.fourUp, fourUp)]),
    children: /*#__PURE__*/_jsx("div", {
      className: css.loader
    })
  });
};

Kid.defaultProps = {
  fourUp: false
};
Kid.propTypes = {
  fourUp: PropTypes.bool
};

var CollectionLoading = function CollectionLoading(_ref3) {
  var _ref3$filterless = _ref3.filterless,
      filterless = _ref3$filterless === void 0 ? false : _ref3$filterless,
      fourUp = _ref3.fourUp,
      numUp = _ref3.numUp;
  var total = fourUp ? 4 : numUp;

  var kids = /*#__PURE__*/_jsx("ul", {
    className: css.list,
    "aria-busy": "true",
    children: _toConsumableArray(Array(total).keys()).map(function (_, idx) {
      return /*#__PURE__*/_jsx(Kid, {
        fourUp: fourUp
      }, idx);
    })
  });

  if (fourUp) {
    return kids;
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!filterless && /*#__PURE__*/_jsx("div", {
      "aria-hidden": "true",
      className: css.filterBar
    }), /*#__PURE__*/_jsx("div", {
      "aria-busy": "true",
      className: css.root,
      children: kids
    })]
  });
};

CollectionLoading.defaultProps = {
  fourUp: false,
  numUp: 3
};
CollectionLoading.propTypes = {
  fourUp: PropTypes.bool,
  filterless: PropTypes.bool,
  numUp: PropTypes.number
};
export default /*#__PURE__*/memo(CollectionLoading);